import { format } from "date-fns";
import { msg } from "@lingui/core/macro";
import type { I18n, MessageDescriptor } from "@lingui/core";
import type { ActivityLogEntry } from "@/lib/api/services/activity.api";

const ACTION_LABELS: Record<string, MessageDescriptor> = {
  CREATE: msg`Created`,
  UPDATE: msg`Updated`,
  DELETE: msg`Deleted`,
};

export function activityActionLabel(entry: ActivityLogEntry, i18n: I18n): string {
  const descriptor = ACTION_LABELS[entry.action];
  const verb = descriptor ? i18n._(descriptor) : entry.action;
  return `${verb} ${entry.entityType}`.trim();
}

export function activityEntityLabel(entry: ActivityLogEntry): string {
  return entry.entityId
    ? `${entry.entityType} #${entry.entityId}`
    : entry.entityType;
}

export function activityWhen(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? "—"
    : format(date, "dd MMM yyyy · HH:mm");
}

export function activityRowsToCsv(rows: ActivityLogEntry[], i18n: I18n): string {
  const escape = (v: string) => `"${v.replace(/"/g, '""')}"`;
  const header = [
    i18n._(msg`Action`),
    i18n._(msg`Entity`),
    i18n._(msg`When`),
    i18n._(msg`IP`),
    i18n._(msg`Actor`),
  ];
  const lines = rows.map((r) =>
    [
      activityActionLabel(r, i18n),
      activityEntityLabel(r),
      activityWhen(r.createdAt),
      r.ipAddress ?? "",
      r.actor?.name ?? "",
    ]
      .map((v) => escape(String(v)))
      .join(","),
  );
  return [header.join(","), ...lines].join("\n");
}
